import { render } from "./Image_Swiper_Set.vue?vue&type=template&id=54b62660&scoped=true"
import script from "./Image_Swiper_Set.vue?vue&type=script&lang=js"
export * from "./Image_Swiper_Set.vue?vue&type=script&lang=js"

import "./Image_Swiper_Set.vue?vue&type=style&index=0&id=54b62660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b62660"]])

export default __exports__